import { ToastManagerStore } from "@core/presentacion/component/feedback/toast-manager/toast-manager.store";
import { PublicUtilityRepository } from "@entity/data/repositories/public-utility.repository";
import { inject, injectable } from "inversify";

@injectable()
export class DeletePublicUtilityUseCase {
    constructor(
        @inject(PublicUtilityRepository)
        private readonly publicUtilityRepository: PublicUtilityRepository,
    ) {}

    async execute(publicUtilityId: number): Promise<void> {
        const result =
            await this.publicUtilityRepository.delete(publicUtilityId);

        if (result.isLeft()) {
            ToastManagerStore.error(result.getLeftOrThrow().message);
        }

        ToastManagerStore.success();
    }
}
